<template>
  <div>
    <div class="search-wrapper">
      <input v-model="q" v-on:keydown.enter="addTag()"
             type="text"
             ref="searchTag"
             :placeholder="tags.length === 0 ? $t('tags_manager.create_a_tag') : $t('tags_manager.search_tag')"
             class="form-control" />
    </div>

    <div class="selectable-tags-wrapper" v-scroll='scroll'>
      <div v-if="q.length > 0" @click="addTag()" class="selectable-tag">
        <b><i class="fa fa-plus"></i> {{ $t('tags_manager.create_tag') }}:</b> {{q }}
      </div>

      <div v-for="tag in orderedTags" @click="toggleTag(tag) " :class="[{ 'selected': selectedTags.indexOf(tag.id) !== -1}, 'selectable-tag']">
        <i class="fa fa-tag"></i>
        {{ tag.name }}
      </div>

      <div v-show='loading'>
        {{ $t('shared.loading') }}
      </div>
    </div>

    <div @click="submitTags" class="btn btn-primary btn-sm">
      {{ $t('products.list.submit') }}
    </div>
  </div>
</template>

<script>
  export default {
    props: ['record'],
    data() {
      return {
        q: '',
        tags: [],
        selectedTags: [],
        loading: true,
        opened: false,
        page: 0,
      }
    },
    created() {
      this.loadMoreOptions()

      this.debouncedLoadMoreOptions = this._debounce(() => {
        this.loading = true
        this.noMoreResults = false
        this.page = 0
        this.tags = []

        this.loadMoreOptions()
      }, 500)
    },
    watch: {
      q() {
        this.debouncedLoadMoreOptions()
      }
    },
    computed: {
      orderedTags() {
        return this.tags.slice().sort((a, b) => {
          return this.selectedTags.indexOf(a.id) !== -1 && this.selectedTags.indexOf(b.id) === -1 ? -1 : a.name.localeCompare(b.name)
        })
      }
    },
    methods: {
      addTag() {
        if (this.q.length > 0) {
          this.store.createTag({ name: this.q }).then(({data}) => {
            this.q = ''
            this.page = 0
            this.tags = []
            this.noMoreResults = false
            this.selectedTags.push(data.id)

            this.$toastr.success(this.$t('products.list.tag_created'))
          })
        }
      },
      submitTags() {
        if (this.selectedTags.length == 0)
          return

        let formData = {
          tag_ids: this.selectedTags,
          record_id: this.record.id
        }

        this.axios.post("/connected_tags/", formData).then(() => {
          this.$emit('reload-record')
        })
      },
      toggleTag(tag) {
        let selected = this.selectedTags
        selected.indexOf(tag.id) === -1 ? selected.push(tag.id) : selected.splice(this.selectedTags.indexOf(tag.id), 1)
      },
      loadMoreOptions() {
        this.loading = true

        this.listStore.getTags({ q: this.q, page: this.page + 1 }).then((data) => {
          this.loading = false
          this.page = data.meta.page

          if (data.data.length > 0)
            this.tags = this.tags.concat(data.data)
          else
            this.noMoreResults = true
        })
      },
      scroll(e) {
        if (this.loading || this.noMoreResults)
          return

        if (e.target.scrollTop / (e.target.scrollHeight - e.target.clientHeight) > 0.8) {
          this.loadMoreOptions()
        }
      },
    }
  }
</script>

<style lang="sass">
  @import "../../styles/tag_manager.sass"
  .tags-data
    .search-wrapper
      margin-bottom: 10px
    .btn
      float: right
      margin-top: 10px
      margin-right: 10px
      font-size: 12px
</style>
